import { render, staticRenderFns } from "./activitycategory.vue?vue&type=template&id=19229cfe"
import script from "./activitycategory.vue?vue&type=script&lang=js"
export * from "./activitycategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports